import PageConsumption from './PageConsumptionContainer';

export default PageConsumption;
